import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/platform-defaults')({
  component: lazyRouteComponent(() => import('./-platform-defaults.lazy'), 'default'),
});
